import * as THREE from 'three';

export class Text{
	constructor(textOption){
		this.textOption = textOption;
		
	}
}


// WEBPACK FOOTER //
// ./src/plugins/drawings3D/models/Text.js